module.exports = __webpack_public_path__ + "static/img/Lil_Jet.b023569.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Lil_Jet.jpg
// module id = PKNy
// module chunks = 1